import React, { useRef } from 'react';
import styles from './Adv.module.scss';
import clsx from 'clsx';
import { ADV_CONTENT } from '../../constants/marketingContent';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(useGSAP, ScrollTrigger);

const Adv = () => {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  useGSAP(
    () => {
      const cards = cardsRef.current.filter(Boolean);

      if (!cards.length) {
        return;
      }
      const primaryCard = cards.find((card) => card.classList.contains(styles.cardPrimary));
      const isPhoneViewport = window.matchMedia('(max-width: 560px)').matches;

      const desktopScaleTargets = cards.map((card) => {
        const isPrimary = card.classList.contains(styles.cardPrimary);
        // const isCompactLayout = window.matchMedia('(max-width: 1080px)').matches;

        // if (isCompactLayout) {
        //   return 1;
        // }

        return isPrimary ? 1.1 : 0.95;
      });
      const desktopOpacityTargets = cards.map((card) => {
        const isPrimary = card.classList.contains(styles.cardPrimary);
        // const isCompactLayout = window.matchMedia('(max-width: 1080px)').matches;

        // if (isCompactLayout) {
        //   return 1;
        // }

        return isPrimary ? 1 : 0.6;
      });

      gsap.set(cards, { autoAlpha: 0, scale: 1, transformOrigin: 'center center' });

      const revealTimeline = gsap.timeline({
        defaults: { ease: 'power3.out' },
        paused: true,
      });
      revealTimeline.to(cards, { autoAlpha: 1, scale: 1, duration: 0.8 });

      const emphasisTimeline = gsap.timeline({
        defaults: { ease: 'power3.out' },
        paused: true,
      });
      emphasisTimeline.to(cards, {
        scale: (index) => desktopScaleTargets[index],
        opacity: (index) => desktopOpacityTargets[index],
        duration: 0.3,
      });

      const playEmphasisAfterReveal = () => {
        if (emphasisTimeline.isActive() || emphasisTimeline.progress() > 0) {
          return;
        }

        if (revealTimeline.progress() < 1) {
          revealTimeline.eventCallback('onComplete', () => {
            revealTimeline.eventCallback('onComplete', null);
            emphasisTimeline.play();
          });
          return;
        }

        emphasisTimeline.play();
      };

      ScrollTrigger.create({
        trigger: sectionRef.current,
        start: 'top 55%',
        once: true,
        onEnter: () => {
          revealTimeline.play();

          if (!isPhoneViewport || !primaryCard) {
            revealTimeline.eventCallback('onComplete', () => {
              revealTimeline.eventCallback('onComplete', null);
              emphasisTimeline.play();
            });
          }
        },
      });

      if (isPhoneViewport && primaryCard) {
        ScrollTrigger.create({
          trigger: primaryCard,
          start: 'top bottom',
          end: 'bottom top',
          onUpdate: (self) => {
            const rect = primaryCard.getBoundingClientRect();
            const fullyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

            if (fullyVisible) {
              playEmphasisAfterReveal();
              self.kill();
            }
          },
        });
      }
    },
    { scope: sectionRef },
  );

  return (
    <section className={clsx(styles.wrap)} ref={sectionRef} id="adv">
      <div className="container">
        <div className={clsx(styles.head)}>
          <div className={clsx(styles.title, 'title')}>{ADV_CONTENT.title}</div>
          <p className={clsx(styles.subtitle)}>{ADV_CONTENT.subtitle}</p>
        </div>

        <div className={clsx(styles.cards)}>
          {ADV_CONTENT.cards.map((card, index) => (
            <article
              key={card.id}
              className={clsx(styles.card, card.isPrimary && styles.cardPrimary)}
              ref={(el) => {
                cardsRef.current[index] = el;
              }}>
              <div className={clsx(styles.cardHead)}>
                <div className={clsx(styles.cardTitle)}>{card.title}</div>
                {card.badge ? <div className={clsx(styles.cardBadge)}>{card.badge}</div> : null}
              </div>

              <p className={clsx(styles.cardLead)}>{card.lead}</p>

              <div className={clsx(styles.points)}>
                {card.points.map((point) => (
                  <div key={point.id} className={clsx(styles.point)}>
                    <div className={clsx(styles.pointLabel)}>{point.label}</div>
                    <div className={clsx(styles.pointValue)}>{point.value}</div>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>

        <p className={clsx(styles.afterword)}>{ADV_CONTENT.afterword}</p>
      </div>
    </section>
  );
};

export default Adv;
